/**
 * TanStack Query hooks for `branded-partner-portal-per-sub-network`.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	detail,
	list,
	brandedPartnerPortalPerSubNetworkQueryKeys,
	type CreatePortalBody,
	type CreatePortalResponse,
	type DetailPortalResponse,
	type ListPortalResponse,
} from "./api";

export function useBrandedPartnerPortalPerSubNetworkList(): UseQueryResult<ListPortalResponse, Error> {
	return useQuery({
		queryKey: brandedPartnerPortalPerSubNetworkQueryKeys.list(),
		queryFn: list,
	});
}

export function useBrandedPartnerPortalPerSubNetworkDetail(
	network_id: string,
	enabled = true,
): UseQueryResult<DetailPortalResponse, Error> {
	return useQuery({
		queryKey: brandedPartnerPortalPerSubNetworkQueryKeys.detail(network_id),
		queryFn: () => detail(network_id),
		enabled: enabled && !!network_id,
	});
}

export function useBrandedPartnerPortalPerSubNetworkCreate(): UseMutationResult<
	CreatePortalResponse,
	Error,
	CreatePortalBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: brandedPartnerPortalPerSubNetworkQueryKeys.all });
		},
	});
}
